import { Skeleton } from "@ui/skeleton";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";

export interface WelcomeCardParameters {
  backgroundColor: string | null | undefined;
  textColor: string | null | undefined;
  backgroundDarkColor: string | null | undefined;
  textDarkColor: string | null | undefined;
}

interface WelcomeCardProps {
  parameterValues: Partial<WelcomeCardParameters>;
  name: string | undefined;
  welcomeText: string | undefined;
  departmentWelcomeText: string | undefined;
  isLoading: boolean;
}

export const WelcomeCard = ({
  parameterValues,
  name,
  welcomeText,
  departmentWelcomeText,
  isLoading,
}: WelcomeCardProps) => {
  const isLoadingVisible = useIsLoadingVisibile(isLoading && !name);

  return (
    <div
      className={`relative w-full ${
        (isLoadingVisible || isLoading) && "h-[375px]"
      } px-10 pb-[35px]`}
    >
      <div className="absolute top-0 w-full px-10 ltr:left-0 rtl:right-0">
        <WelcomeCardLoading isLoading={isLoadingVisible} />
      </div>
      <div
        className="flex w-full flex-col items-start justify-center gap-y-2 rounded-lg p-5"
        style={{
          backgroundImage: `linear-gradient(to right, ${parameterValues.backgroundColor} , ${parameterValues.backgroundDarkColor})`,
          color: parameterValues.textDarkColor || "white",
        }}
      >
        <div className="text-[32px] font-medium">{name}</div>
        <div className="text-[24px]">{welcomeText}</div>
        <div className="text-[18px]">{departmentWelcomeText}</div>
      </div>
    </div>
  );
};

const WelcomeCardLoading = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? (
    <Skeleton
      className={`h-[140px] w-full rounded-[12px] bg-[#f4f4f5] dark:bg-[#27272a]`}
    ></Skeleton>
  ) : null;
};
